import { Button } from "@mui/material";
import { Container } from "@mui/system";
import React from "react";
import { BsPlayCircle } from "react-icons/bs";
import { Link } from "react-router-dom";
import "../assets/scss/_cardio_3page.scss";
import CardBoxMoreImage from "../components/CardBoxMoreImage";
import CenterContentBox from "../components/CenterContentBox";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { useDispatch } from "react-redux";
import { getFilter } from "../redux/actions/filterActions";
import $2 from "../assets/videos/1-2.mp4";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "90%",
};

const CardioPerformance = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <section className="cardio-page">
      <div>
        <Modal
          className="relative overflow-y-auto"
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <>
            <span
              onClick={handleClose}
              className="video-close-icon absolute top-0 right-0 mr-6 mt-6 text-5xl font-black text-white hover:text-slate-500 cursor-pointer"
            >
              ×
            </span>
            <Fade in={open}>
              <Box sx={style}>
                <video playsinline
                  playsInline={true}
                  height="auto"
                  width="auto"
                  autoPlay
                  controls
                >
                  <source width="auto" height="auto" src={$2}></source>
                </video>
              </Box>
            </Fade>
          </>
        </Modal>
      </div>
      <section
        className="section-1 py-16 md:px-12 relative flex flex-col justify-end md:!bg-cover !bg-contain md:!bg-center !bg-top main-media-height"
        style={{
          height: "70vh",
          background:
            "url(https://images.jhtassets.com/0515cf716c2107e311a64892cd73a735cec9806f/) no-repeat",
        }}
      >
        <Container maxWidth="xl">
          <div className="text-white md:text-6xl">
            <strong className="font-bold">Серия</strong> Endurance
          </div>
        </Container>
        <Button
          onClick={handleOpen}
          className="cardio-button !duration-200 !absolute right-0 md:left-auto left-0 !bg-white !px-4 !py-3 !font-black !text-base hover:!bg-red-700 !text-red-700 hover:!text-white !rounded-none !mr-8"
          style={{ bottom: "-25px" }}
        >
          <BsPlayCircle size={32} fill="#b91c1c" className="mr-3" />
          СМОТРЕТЬ ВИДЕО
        </Button>
      </section>
      <section className="section-2 py-16 md:px-12">
        <Container maxWidth="xl" className="mb-16 md:!px-0">
          <div className="leading-7 md:w-3/4 mb-6" style={{ color: "#333" }}>
            Если нужен идеальный вариант для активного использования и
            регулярных тренировок, но места не хватает, а бюджет ограничен, то с
            серией тренажеров Endurance у вас будет выбор. Рациональный дизайн
            упрощает выполнение упражнений, сохраняя мощность, способную бросить
            вызов настоящим фанатам фитнеса. При этом вся серия Endurance
            разработана и испытана таким образом, чтобы служить долгие годы при
            самых высоких нагрузках.
          </div>
          <a
            onClick={() => {
              window.localStorage.removeItem("category_id");
              window.localStorage.setItem("seria_id", 2);
              dispatch(
                getFilter({
                  series: 2,
                })
              );
            }}
            href="/cardio/catalog?series=endurance"
            className="inline-block px-4 py-3 bg-red-600 hover:bg-red-700 duration-200 text-white font-black"
          >
            Все продукты серии Endurance
          </a>
        </Container>
        <CardBoxMoreImage
          title="Линейка оборудования"
          subtitle="Серия кардиотренажеров для клубов любого формата включает беговую дорожку, лестницу-эскалатор, степпер, эллиптический эргометр, вертикальный велоэргометр и горизонтальный велоэргометр."
          image="https://images.jhtassets.com/ffec218bf13a17bb6d1cb4f0d2395426a0240c9d/"
          contentBgColor="#000"
          contentRight={true}
          contentWidth="25%"
          contentTitleColor="#e6e5e5"
          contentSubtitleColor="#c2c6c9"
          contentLinkColor="#861711"
          linkTo="/cardio/consoles"
        />
      </section>
      <section
        className="section-4 py-16 md:px-12"
        style={{ background: "linear-gradient(171.76deg,#253746,#000)" }}
      >
        <Container maxWidth="xl" className="md:!px-0">
          <div className="grid lg:grid-cols-2 gap-6 mb-16">
            <div>
              <img
                src="https://images.jhtassets.com/3eb21ec109572e47e7879f7b25337f1baf5cfb06/"
                alt=""
              />
              <div className="px-6 py-12" style={{ background: "#fff" }}>
                <div
                  className="font-black text-3xl leading-none mb-6"
                  style={{ color: "#4c4c4c" }}
                >
                  Надежность и рациональность
                </div>
                <p
                  className="leading-6"
                  style={{ color: "#666", fontSize: "15px" }}
                >
                  Надежная и рациональная конструкция, помогающая
                  сосредоточиться на выполнении упражнений, позволит каждому без
                  труда приступить к тренировкам, и при этом удовлетворит
                  потребности опытных пользователей в повышенных нагрузках.
                </p>
              </div>
            </div>
            <div>
              <img
                src="https://images.jhtassets.com/3a5791a6e199e9816034f04054043a3fdfe9be7a"
                alt=""
              />
              <div className="px-6 py-12" style={{ background: "#fff" }}>
                <div
                  className="font-black text-3xl leading-none mb-6"
                  style={{ color: "#4c4c4c" }}
                >
                  Гибкие опции
                </div>
                <p
                  className="leading-6"
                  style={{ color: "#666", fontSize: "15px" }}
                >
                  Различные опции позволяют сформировать предложение, подходящее
                  именно вашему залу, поэтому оборудование серии Endurance
                  всегда сможет удовлетворить ваши актуальные потребности в
                  отношении свойств, функций и бюджета.
                </p>
              </div>
            </div>
          </div>
          <CardBoxMoreImage
            title="Консоли Matrix Cardio"
            subtitle="Оснащение вашего оборудования подходящей консолью может сделать его простым и приятным в использовании, либо же полностью цифровым, с богатым выбором опций и развлечений. Консоли с подключением к Wi-Fi обеспечат вам доступ к нашим самым эффективным сетевым решениям, таким как Engage 360, Community 360 и Asset Management."
            image="https://images.jhtassets.com/8b52d387a7c904745934139abca0529f1949e508/"
            link="Узнать больше о консолях /"
            contentBgColor="#c2c6c9"
            contentRight={true}
            contentWidth="25%"
            contentTitleColor="#4c4c4c"
            contentSubtitleColor="#666"
            contentLinkColor="#e1261c"
          />
        </Container>
      </section>
      <section className="section-5 py-16">
        <CenterContentBox
          title="Добейтесь большего с Matrix"
          subtitle="Свяжитесь с нашими менеджерами по продажам, чтобы получить комплексные решения для вашего бизнеса уже сегодня."
          link="Обратная связь"
          titleColor="#4C4C4F"
          subtitleColor="#191919"
          linkTo="/about-us"
        />
      </section>
    </section>
  );
};

export default CardioPerformance;
